var React = require('react');

function Auxiliary (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Force Auxiliary"),React.createElement("path",{"id":"path1308","className":"cls-1","d":"M39,68.17V59.83l-25-25,25-25H89l25,25-25,25v8.34l25,25-25,25H39l-25-25Z","key":2})]);
}

Auxiliary.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Auxiliary;

Auxiliary.default = Auxiliary;
